import { useNavigate } from 'react-router';

import { useStartAiReviewMutation } from '../queries/useStartAiReviewMutation';
import { ScenarioRoutePaths } from '../routes/ScenariosRoutePaths';
import { useCancelAiReviewMutation } from '../queries/useCancelAiReviewMutation/useCancelAiReviewMutation';
import { useStartAiExtendedReviewMutation } from '../queries/useStartAiExtendedReviewMutation';
import { useCancelAiExtendedReviewMutation } from '../queries/useCancelAiExtendedReviewMutation';

export const useUserSimulationControl = (
  mode: 'authorized' | 'guest' = 'authorized'
) => {
  const { mutateAsync: startSimulation } = useStartAiReviewMutation(mode);
  const { mutateAsync: stopSimulation } = useCancelAiReviewMutation(mode);
  const { mutateAsync: startExtendedSimulation } =
    useStartAiExtendedReviewMutation();

  const { mutateAsync: stopExtendedSimulation } =
    useCancelAiExtendedReviewMutation();

  const navigate = useNavigate();

  const startExtended = async (scenarioId: string, persona: 'accessible' | 'default' | string, amount: number) => {
    await startExtendedSimulation({ scenarioId, persona, amount });
  };

  const start = async (
    teamId: string,
    workspaceId: string,
    scenarioId: string,
    persona: 'accessible' | 'default' | string = 'default',
    amount = 1,
    redirect = false
  ) => {
    const res =
      amount === 1
        ? await startSimulation({
            scenarioId,
            persona
          })
        : await startExtended(scenarioId, persona, amount);

    if (redirect && amount > 1) {
      navigate(ScenarioRoutePaths.challengeDetails(teamId, workspaceId, scenarioId));
    }
    
    if (!res) {
      return;
    }

    const { entityId: startedReviewId } = res;

    if (!startedReviewId) {
      return;
    }

    if (redirect && amount === 1) {
      navigate(
        ScenarioRoutePaths.challengeSimulation(
          teamId,
          workspaceId,
          scenarioId,
          startedReviewId
        )
      );
    }

    return startedReviewId;
  };

  const stop = async (
    workspaceId: string,
    scenarioId: string,
    shareToken: string,
    reviewId: string
  ) => {
    await stopSimulation({
      scenarioId,
      shareToken,
      workspaceId,
      reviewId,
    });
  };

  const stopExtended = async (
    workspaceId: string,
    scenarioId: string,
    shareToken: string,
    reviewId: string
  ) => {
    await stopExtendedSimulation({
      scenarioId,
      shareToken,
      workspaceId,
      reviewId,
    });
  };

  return {
    start,
    startExtended,
    stop,
    stopExtended,
  };
};
